import { render, staticRenderFns } from "./marketing-task.vue?vue&type=template&id=7840fc60&scoped=true&lang=pug&"
import script from "./marketing-task.vue?vue&type=script&lang=js&"
export * from "./marketing-task.vue?vue&type=script&lang=js&"
import style0 from "./marketing-task.vue?vue&type=style&index=0&id=7840fc60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840fc60",
  null
  
)

export default component.exports